import { render } from "./MModal.vue?vue&type=template&id=afdf7d82&scoped=true"
import script from "./MModal.vue?vue&type=script&lang=js"
export * from "./MModal.vue?vue&type=script&lang=js"

import "./MModal.vue?vue&type=style&index=0&id=afdf7d82&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdf7d82"]])

export default __exports__